import { defineStore } from 'pinia';
export const useChatSettingsStore = defineStore('chatsettingsstore', {
  state() {
    return {
      chatThemeSettings: {},
      tvmChatActions: {},
    };
  },
});
